<span *ngFor="let i of fullStarsToDisplay">
    <i class="fas fa-star"></i>
</span>
<span *ngFor="let i of emptyStarsToDisplay">
    <i class="far fa-star"></i>
</span>